module.exports = __webpack_public_path__ + "img/16.e9a6d58d.jpg";